import React, { useState } from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { getNavbarData } from "../../data/navbarFooter";
import "./navbar.css";

const CustomNavbar = () => {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);
  const navbarData = getNavbarData();

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <Navbar
      expand="lg"
      expanded={expanded}
      onToggle={setExpanded}
      className="premium-navbar"
    >
      <Container fluid className="col-md-11 mx-auto px-lg-5 px-3">
        {/* Logo */}
        <Navbar.Brand 
          as={Link} 
          to="/"
          onClick={() => setExpanded(false)}
          className="navbar-brand-custom py-2"
          style={{ cursor: "pointer" }}
        >
          <img
            src={navbarData.logo}
            alt="V Studio"
            className="logo-img"
          />
        </Navbar.Brand>

        <Navbar.Toggle className="border-0 shadow-none" />

        <Navbar.Collapse>
          <Nav className="mx-auto align-items-lg-center text-center">
            {navbarData.navLinks.map((link) => (
              <Nav.Link
                key={link.path}
                as={Link}
                to={link.path}
                onClick={() => setExpanded(false)}
                className={`nav-link-premium ${
                  isActive(link.path) ? "active-link" : ""
                }`}
              >
                {link.label}
              </Nav.Link>
            ))}
          </Nav>

          <div className="d-flex justify-content-lg-end justify-content-center mt-4 mt-lg-0">
            <Button
              as={Link}
              to={navbarData.contactButton.path}
              onClick={() => setExpanded(false)}
              className="contact-btn-premium"
            >
              {navbarData.contactButton.text}
            </Button>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;